/**
 * Helper functions.
 */
export function offsetOfElement(element) {
	let node = element
	let { offsetLeft, offsetTop } = node
	while ((node = node.parentNode) && 'offsetLeft' in node) {
		offsetLeft += node.offsetLeft
		offsetTop += node.offsetTop
	}
	return { offsetLeft, offsetTop }
}

export const clamp = (val, min, max) => Math.min(Math.max(val, min), max)